



















































































































































































import { Component, Vue, Prop ,Watch } from "vue-property-decorator";
import ABTestEditTable from './components/editTable.vue';
import ABTestDisplayTable from './components/displayTable.vue';
import ABTestAddNewDialog from "./components/addNewDialog.vue";
import ABTestAddOldDialog from "./components/addOldDialog.vue";
import ABTestDisplayTableItemDialog from './components/displayTableItemDialog.vue';
import ABTestCustomDialog from "./components/customDialog.vue";
import SmartAbVerdictBanner from "./components/SmartAbVerdictBanner.vue";
import SmartAbHistory from "./components/SmartAbHistory.vue";
import SmartAbCreateDialog, { SMART_AB_PRESET, SmartAbPresetType } from "../components/SmartAbCreateDialog.vue";
import pluginDialog from "../components/pluginDialog.vue";
import { fetchPublishGate, PublishGateView } from "../components/shopifyThemeGate";
import { Message } from "element-ui";
import { toastFailMessage } from "@/i18n/failMessage";
import {
  companyMeasureSave,
  getAbTest,
  saveAbtestDraft,
  remoteAbtestPop,
  publishAbtest,
  cancelAbtest,
  abtestChooseWin,
  getPopWindowDetail,
  endSmartABTest,
  confirmSmartABTestWin,
  nextSmartABTestRound,
} from "@/services/api";
import { formRulesEditPath, isAllTriggerConditionsSelected, parseFormRules } from "./triggerPresetGuard";
import { normalizeAbtestMeasures } from "@/utils/abtestMeasure";
import { resolveAbtestMetricDisplayMode, shouldUseAbtestAttributionMetrics } from "@/utils/abtestMetricDisplay";
import { isEnableAttributionWindow } from "@/utils/experiment";

@Component({
  components: {
    ABTestEditTable,
    ABTestDisplayTable,
    ABTestAddNewDialog,
    ABTestDisplayTableItemDialog,
    ABTestCustomDialog,
    ABTestAddOldDialog,
    SmartAbVerdictBanner,
    SmartAbHistory,
    SmartAbCreateDialog,
    pluginDialog,
  }
})

export default class wheelOfFortuneABTest extends Vue {
  @Prop({
    type: Object,
    default: undefined,
  })
  abTestPop?:any;
  
  abTestDetail:any = {};

  addNewDialogShow = false;
  addOldDialogShow = false;
  changeTableColumnDialogShow = false;
  customDialogShow = false;
  plugInDialogShow = false;
  isShopify = false;
  gateMode = '';
  authorizationUrl = '';
  recheckMessage = '';
  themeGatePassed = false;
  publishGateCallback: ((success: boolean) => void) | null = null;
  showAddNewPop = false;

  customDialogConfig:{title:string;desc:string;type:string;okText:string;cancelText?:string;other?:any} = {
    title: '',
    desc: '',
    type: '',
    okText: '',
    cancelText: '',
    other: undefined as any,
  }

  // 选择状态，用于选择测试组
  chooseState = false;
  chooseId = '';
  name = '';
  smartNextVisible = false;
  smartNextFormType: number | undefined = undefined;
  triggerBlockedVisible = false;

  get isSmart() {
    // 仅当详情明确标记为 Smart 实验（有 smart 轮次）时开 Smart UI；灰度公司存量普通 AB 不误开
    return this.abTestDetail?.smartTestEnabled === true;
  }

  get smartRoundNo() {
    return this.abTestDetail?.smartRoundNo || null;
  }

  /** 当前轮选中的快捷配置类型（1玩法 / 2触发 / 3自定义） */
  get smartPresetType(): number | null {
    if (!this.isSmart) {
      return null;
    }
    const fromDetail = this.abTestDetail?.smartPresetType;
    if (fromDetail === 1 || fromDetail === 2 || fromDetail === 3) {
      return fromDetail;
    }
    const roundNo = this.smartRoundNo;
    const list = this.smartRoundHistory || [];
    const current = list.find((item: { roundNo?: number }) => item.roundNo === roundNo)
      || list.find((item: { status?: number }) => item.status === 0 || item.status === 1)
      || list[0];
    const preset = current?.presetType;
    return preset === 1 || preset === 2 || preset === 3 ? preset : null;
  }

  /** 稿：当前轮标题为「测试设置」，玩法名只出现在快捷创建弹窗 */
  get smartSettingTitle(): string {
    return this.$tx("setting.abtest.set", "测试设置");
  }

  get smartVerdict() {
    return this.abTestDetail?.smartVerdict ?? this.abTestDetail?.smartVerdictDetail?.verdict ?? null;
  }

  get smartVerdictDetail() {
    return this.abTestDetail?.smartVerdictDetail || null;
  }

  /** 建议优胜态（verdict=2）才可点确认 */
  get smartSuggestReady(): boolean {
    return this.smartVerdict === 2 && !!this.smartVerdictDetail?.suggestedWinFormId;
  }

  get smartSuggestedLetter(): string {
    const id = this.smartVerdictDetail?.suggestedWinFormId;
    if (!id) return "";
    const list = this.abTestDetail?.abFormList || [];
    const idx = list.findIndex((f: { formId?: string }) => f.formId === id);
    if (idx === 0) return "A";
    if (idx === 1) return "B";
    return "";
  }

  get smartConfirmWinText(): string {
    if (this.smartSuggestReady && this.smartSuggestedLetter) {
      return this.$tx("form.smartAb.confirmWinLetter", "确认 {letter} 为胜出版本").replace(
        "{letter}",
        this.smartSuggestedLetter,
      );
    }
    return this.$tx("form.smartAb.confirmWin", "确认胜出版本");
  }

  get smartMinExposure() {
    const n = Number(this.abTestDetail?.smartMinExposure);
    return !n || n < 1 ? 1000 : n;
  }

  get smartBaselineFormId(): string {
    return this.abTestDetail?.smartBaselineFormId || "";
  }

  get smartRoundHistory() {
    return this.abTestDetail?.smartRoundHistory || [];
  }

  get showSmartHistory(): boolean {
    if (this.isSmart && this.getStatus == 0) {
      return true;
    }
    return this.isSmart && this.pastSmartRoundHistory.length > 0;
  }

  /**
   * 历史实验：已结束轮进列表。
   * 不能按 status===0 排除——后端关闭轮 FormStatus.CLOSE 也是 0，会把第 1～n 轮全部滤掉（草稿页只剩当前轮）。
   * 进行中/草稿只去掉当前 roundNo；取消草稿不进历史。
   */
  get pastSmartRoundHistory() {
    const list = this.smartRoundHistory || [];
    const currentNo = this.smartRoundNo;
    const hideCurrent = this.getStatus === 1 || this.getStatus === 3;
    return list.filter((item: { status?: number; roundNo?: number; endReason?: number }) => {
      if (item.endReason === 4 || item.status === 4) {
        return false;
      }
      if (hideCurrent && currentNo != null && item.roundNo === currentNo) {
        return false;
      }
      return true;
    });
  }

  get getTitle() {
    return this.abTestPop?.title;
  }

  get getStatus () {
    return this.abTestDetail?.status;
  }

  get displayTableKey() {
    const list = this.abTestDetail?.abFormList || [];
    const ids = list.map((item: { formId?: string }) => item?.formId || '').join('-');
    return `${this.getStatus || ''}-${this.smartRoundNo || ''}-${ids}`;
  }

  get getStatusText() {
    if (this.getStatus === 1 || this.getStatus === 0) {
      return this.$tx('form.ab.view', '查看')
    } else if (this.getStatus === 3) {
      return this.$tx('form.ab.create', '创建')
    }
    return '';
  }

  get needAdd() {
    // Smart 草稿也可删版本，删后不足 2 个时显示添加入口（与线上普通 AB 一致）
    return this.getStatus == 3 && (this.abTestDetail.abFormList || []).length < 2;
  }

  showEndSmartAbtest() {
    this.customDialogConfig = {
      title: this.$tx('form.smartAb.endTitle', '结束实验（保留基线版本）'),
      desc: this.$tx(
        'form.smartAb.endDesc',
        '当前未选择胜出版本，结束实验后将无胜出组，本次实验按基线版本保留。',
      ),
      okText: this.$tx('common.confirm', '确认'),
      cancelText: this.$tx('common.cancel', '取消'),
      type: 'smartEnd',
    };
    this.customDialogShow = true;
  }

  confirmSmartSuggest() {
    const winFormId = this.smartVerdictDetail?.suggestedWinFormId;
    if (!winFormId) {
      Message.error(this.$tx('form.pleaseSelectWinner', '请选择获胜组'));
      return;
    }
    this.customDialogConfig = {
      title: this.$tx('form.smartAb.confirmSuggestTitle', '确认设为新基线？'),
      desc: this.$tx(
        'form.smartAb.confirmSuggestDesc',
        '确认后将把建议优胜版本写回主弹窗，并结束本轮实验。人工确认前线上版本不会自动变更。',
      ),
      okText: this.$tx('form.smartAb.setAsBaseline', '设为新基线'),
      cancelText: this.$tx('common.cancel', '取消'),
      type: 'smartConfirmSuggest',
      other: winFormId,
    };
    this.customDialogShow = true;
  }

  openNextRoundDialog() {
    this.smartNextVisible = true;
  }

  confirmGoEditTriggers() {
    const formId = this.$route.params.id as string;
    this.triggerBlockedVisible = false;
    this.smartNextVisible = false;
    if (formId) {
      this.$router.push(formRulesEditPath(formId, this.smartNextFormType));
    }
  }

  async isMainFormTriggersAllSelected(formId: string): Promise<boolean> {
    try {
      const res: any = await getPopWindowDetail({ id: formId });
      const detail = res?.data?.data;
      this.smartNextFormType = detail?.type;
      return isAllTriggerConditionsSelected(parseFormRules(detail?.settings));
    } catch {
      return false;
    }
  }

  async onSmartNextPresetSelect(presetType: SmartAbPresetType) {
    const formId = this.$route.params.id as string;
    if (presetType === SMART_AB_PRESET.TRIGGER && await this.isMainFormTriggersAllSelected(formId)) {
      this.triggerBlockedVisible = true;
      return;
    }
    this.smartNextVisible = false;
    nextSmartABTestRound({ id: formId, presetType }).then((res: any) => {
      if (res?.data?.code === 0) {
        Message.success(this.$tx('form.smartAb.nextRoundOk', '已创建下一轮草稿'));
        this.changeDetail();
      } else {
        Message.error(toastFailMessage(res.data));
      }
    }).catch(() => {
      // interceptor 已 toast；避免未处理 rejection
    });
  }

  created() {
    if (!!this.$route.params.id) {
      this.getABDetail(this.$route.params.id)
    }
  }

  addNewPop(type: number) {
    if (type == 1) {
      this.addOldDialogShow = true;
    } else {
      this.addNewDialogShow = true;
    }
  }

  jumpToList() {
    this.$router.push('/wheel_of_fortune/list');
  }

  changeName() {
    if (this.name.length > 70) {
      Message.error(this.$tx('form.supportsUp70Characters', '最多支持 70 个字符'));
    }
    this.name = `${this.name??''}`.substring(0, 70);
    this.saveDraftNoTip();
  }

  changeDetail() {
    this.getABDetail(this.$route.params.id);
  }

  getABDetail(parentPopId: any) {
    // 请求ab测详情
    getAbTest({id:parentPopId}).then((res:any) => {
      const data = res.data.data || {};
      this.abTestDetail = {
        ...data,
        abFormList: Array.isArray(data.abFormList) ? data.abFormList.slice() : [],
      };
      this.name = this.abTestDetail.groupName;
      // if (this.abTestDetail) {
      //   if (this.abTestDetail.sceneType === 1) {
      //     // 场景是1的，自动补全
      //     if (this.abTestDetail.abFormList) {
      //       let rate = 50;
      //       if (this.abTestDetail.abFormList.length > 0) {
      //         rate = 100 - this.abTestDetail.abFormList[0].flowRate;
      //       }
      //       this.abTestDetail.abFormList.push({flowRate:rate});
      //     } else {
      //       this.abTestDetail.abFormList = [{flowRate:50}];
      //     }
      //   }
      // }
    })
    // setTimeout(() => {
      
    // this.abTestDetail = {
    //   "id": "3e989ba7a4484ec090988a2b2df121a7",
    //   "companyId": 30,
    //   "groupName": "Departure coupon 02KEntebA/B测试实验",
    //   "triggerEventType": 1,
    //   "sceneType":0,
    //   "status": 3,
    //   "abFormList": [{
    //       "formId":"b6441c21d3dc4553bbdafb02a7addcdd",
    //       "type":2,
    //       "name":"主弹窗名称副本",
    //       "winStatus":0,
    //       "flowRate":20,
    //       "participationCnt":200,
    //       "viewCnt":100,
    //       "signupCnt":30,
    //       "phoneCnt":20,
    //       "orderCnt":60
    //   },
    //   {
    //       "formId":"3f6b3ce13db645eea81b6c578f5cfe83",
    //       "type":1,
    //       "name":"主弹窗名称副本副本",
    //       "winStatus":1,
    //       "flowRate":80,
    //       "participationCnt":800,
    //       "viewCnt":160,
    //       "signupCnt":10,
    //       "phoneCnt":10,
    //       "orderCnt":30
    //   }]
    // }
    // this.name = this.abTestDetail.groupName;
    // console.log('change data', this.abTestDetail);
    // }, 2000);
  }

  changeAbtest(temp:any) {
    this.abTestDetail = temp;
  }
  deleteItem(index:number) {
    this.customDialogConfig = {
      title: this.$tx('form.ab.deleteTitle', '确定删除?'),
      desc: this.$tx('form.ab.deleteDesc', '删除后将无法恢复，确定删除「{{name}}」吗？', { name: this.abTestDetail.abFormList[index].name }),
      okText: this.$tx('campaign.autoList.delete', '删除'),
      type: 'delete',
      other: index,
    };
    this.customDialogShow = true;
  }
  
  showCancelAbtest() {
    // 取消AB测
    this.customDialogConfig = {
      title: this.$tx('form.ab.cancelTitle', '确定取消该 A/B 测试吗？'),
      desc: this.$tx('form.confirmCancelingThisSignUp', '确认取消订阅工具 A/B 测试，取消将清除实验组设置内容'),
      okText: this.$tx('campaign.auto.confirmCancel', '确定取消'),
      cancelText: this.$tx('campaign.autoListV2.notNow', '再想想'),
      type: 'cancel',
    }
    this.customDialogShow = true;
    window?.gtagClick('form_abTest_cancel','弹窗_取消ab测试')
  }

  saveDraftNoTip() {
    // 保存草稿
    saveAbtestDraft({
      id: this.abTestDetail.id,
      groupName: this.name,
      abFormList: this.abTestDetail.abFormList,
    }).then((res:any) => {
    }).catch(() => {});
  }

  saveDraft() {
    // 保存草稿
    saveAbtestDraft({
      id: this.abTestDetail.id,
      groupName: this.name,
      abFormList: this.abTestDetail.abFormList,
    }).then((res:any) => {
      Message.success(this.$tx('common.success.save', '保存成功'));
      this.jumpToList();
    })
    window?.gtagClick('form_abTest_save','弹窗_保存ab测试')
  }

  showPublishAbtest() {
    // 发布AB测
    this.customDialogConfig = {
      title: this.$tx('form.ab.publishTitle', '确定发布该 A/B 测试吗？'),
      desc: this.$tx('form.confirmPublishingThisSignUp', '确定发布订阅工具 A/B 测试实验，发布将立即启用实验组订阅工具内容。实验发布，则实验内变体设置将不可更改'),
      okText: this.$tx('form.ab.publish', '发布'),
      cancelText: this.$tx('common.cancel', '取消'),
      type: 'confirm',
    }
    this.customDialogShow = true;
    window?.gtagClick('form_abTest_start','弹窗_开启ab测试')
  }

  chooseSuccess() {
    // 选择获胜组
    this.chooseState = true;
  }

  updateChooseResult(chooseId:any) {
    this.chooseId = chooseId;
  }

  confirmChoose() {
    // 确认获胜组
    if (!!this.chooseId) {
      this.chooseState = false;
      abtestChooseWin({
        mainFormId: this.abTestDetail.id,
        winFormId: this.chooseId,
      }).then((res:any) => {
        if (res.data.code === 0) {
          this.changeDetail();
        } else {
          Message.error(toastFailMessage(res.data));
        }
      })
    } else {
      Message.error(this.$tx('form.pleaseSelectWinner', '请选择获胜组'));
    }
    window?.gtagClick('form_abTest_end','弹窗_结束ab测试')
  }

  private validateSmsRulesByFormDetail(formDetail: any): { valid: boolean; message?: string; hasSms: boolean } {
    const settings = formDetail?.settings || {};
    const rules = settings?.rules || {};
    const startForms: any[] = settings?.start || [];
    const middleForms: any[] = settings?.middle || [];
    const hasMiddlePage = middleForms.length > 0 || rules?.stepDisplay === true;
    const isMobileField = (item: any) => (item?.type || '').toString().trim().toLowerCase() === 'mobile number';
    const isSmartCollect = (item: any) => (item?.collectWay || '').toString().trim().toLowerCase() === 'smart';

    const startSmsEnabled = rules?.buttonAction === 'sms';
    const middleSmsEnabled = rules?.middleButtonAction === 'sms';
    const hasSmsEnabled = startSmsEnabled || middleSmsEnabled;
    if (!hasSmsEnabled) {
      return { valid: true, hasSms: false };
    }

    const startSmartEnabled = startForms.some(item => isMobileField(item) && isSmartCollect(item));
    const middleSmartEnabled = middleForms.some(item => isMobileField(item) && isSmartCollect(item));
    const startHasOtherFields = startForms.some(item => !isMobileField(item));
    const middleHasOtherFields = middleForms.some(item => !isMobileField(item));

    if (hasMiddlePage && startSmsEnabled) {
      return { valid: false, message: this.$tx('form.edit.err.smsNotStep1', '“通过短信订阅”不支持在表单步骤一设置，请检查后重试。'), hasSms: true };
    }
    if (startSmsEnabled !== startSmartEnabled) {
      return { valid: false, message: this.$tx('form.edit.err.smsNeedSmart', '“通过短信订阅”按钮与“快捷采集”手机号采集项需同时启用，请检查后重试。'), hasSms: true };
    }
    if (hasMiddlePage && middleSmsEnabled !== middleSmartEnabled) {
      return { valid: false, message: this.$tx('form.edit.err.smsNeedSmart', '“通过短信订阅”按钮与“快捷采集”手机号采集项需同时启用，请检查后重试。'), hasSms: true };
    }
    if (startSmsEnabled && startHasOtherFields) {
      return { valid: false, message: this.$tx('form.edit.err.smsPhoneOnly', '“通过短信订阅”仅支持与手机号采集同步骤，请移除其他采集项。'), hasSms: true };
    }
    if (hasMiddlePage && middleSmsEnabled && middleHasOtherFields) {
      return { valid: false, message: this.$tx('form.edit.err.smsPhoneOnly', '“通过短信订阅”仅支持与手机号采集同步骤，请移除其他采集项。'), hasSms: true };
    }
    if (!rules?.smsSubBody || !String(rules.smsSubBody).trim()) {
      return { valid: false, message: this.$tx('form.edit.err.smsEmpty', '短信订阅信息为空，请完善'), hasSms: true };
    }
    if (rules?.terminalType !== 'mobile') {
      return { valid: false, message: this.$tx('form.edit.err.smsMobileOnly', '通过短信订阅仅支持移动端应用'), hasSms: true };
    }
    return { valid: true, hasSms: true };
  }

  private async validateAbtestBeforePublish(): Promise<{ valid: boolean; message?: string; hasSms: boolean; metricDisplayMode?: string }> {
    const abFormList: any[] = this.abTestDetail?.abFormList || [];
    if (!abFormList.length) {
      return { valid: true, hasSms: false };
    }

    let hasSms = false;
    const formDetails: any[] = [];
    for (const item of abFormList) {
      if (!item?.type) {
        continue;
      }
      const formId = item?.formId;
      // https://tower.im/teams/860167/todos/39696/ 修复，弹窗type为null时 也不需要调用getPopWindowDetail接口
      if (!formId || !item?.type) { // bug 
        continue;
      }
      try {
        const { data, status }: any = await getPopWindowDetail({ id: formId }, true);
        if (status === 200) {
          const formDetail = data?.data;
          const result = this.validateSmsRulesByFormDetail(formDetail);
          hasSms = hasSms || result.hasSms;
          if (!result.valid) {
            return result;
          }
          formDetails.push(formDetail);
        }
      } catch (error) {
        return { valid: false, message: this.$tx('form.failedLoadExperimentPopupData', '实验内弹窗数据获取失败，请稍后重试'), hasSms };
      }
    }

    return {
      valid: true,
      hasSms,
      metricDisplayMode: resolveAbtestMetricDisplayMode(this.abTestDetail?.sceneType, formDetails),
    };
  }

  public applyPublishGate(view: PublishGateView, showDialog: boolean) {
    this.gateMode = view.mode;
    this.authorizationUrl = view.authorizationUrl;
    this.recheckMessage = view.recheckMessage;
    if (view.integrationType === 1) {
      this.isShopify = true;
    } else if (view.integrationType === 11) {
      this.isShopify = false;
    }
    if (showDialog) {
      this.plugInDialogShow = !view.pass;
    }
    return view.pass;
  }

  public async ensurePublishGate(recheck: boolean) {
    const view = await fetchPublishGate(this.isShopify, recheck, (key, fallback) => this.$tx(key, fallback));
    return this.applyPublishGate(view, true);
  }

  public closePublishGate() {
    this.plugInDialogShow = false;
    this.recheckMessage = '';
  }

  public passThemeGateAndPublish() {
    const callback = this.publishGateCallback;
    this.themeGatePassed = true;
    this.plugInDialogShow = false;
    this.recheckMessage = '';
    this.confirmDialog(callback);
  }
  public continueDespiteGate() {
    this.passThemeGateAndPublish();
  }
  public async confirmPublishGate() {
    if (this.gateMode === 'shopline') {
      this.passThemeGateAndPublish();
      return;
    }
    const passed = await this.ensurePublishGate(true);
    if (!passed) {
      return;
    }
    this.passThemeGateAndPublish();
  }

  async confirmDialog(callback:any) {
    // 确认自定义弹窗
    // 根据条件调取接口完成后回调
    if (this.customDialogConfig.type === 'delete') {
      // 调用删除接口
      // TODO: 模拟删除
      // this.abTestDetail?.abFormList.splice(this.customDialogConfig.other, 1);
      remoteAbtestPop({
        id: this.abTestDetail.abFormList[this.customDialogConfig.other].formId,
      }).then((res:any) => {
        // 完成后回调
        if (callback) {
          callback(res.data.code===0);
        }
        if (res.data.code === 0) {
          this.changeDetail();
        }
      });
    } else if (this.customDialogConfig.type === 'confirm') {
      // TODO: 模拟发布成功
      if (this.name && this.name.length > 0) {
        if (this.abTestDetail.abFormList && this.abTestDetail.abFormList.length >= 2) {
          const validateRes = await this.validateAbtestBeforePublish();
          if (!validateRes.valid) {
            Message.error(validateRes.message || this.$tx('form.validationFailed', '校验失败'));
            if (callback) {
              callback(false);
            }
            return;
          }

          if (!this.themeGatePassed) {
            const passed = await this.ensurePublishGate(false);
            if (!passed) {
              this.publishGateCallback = callback;
              if (callback) {
                callback(false);
              }
              return;
            }
          }
          this.themeGatePassed = false;

          const abFormList = this.abTestDetail.abFormList;
          publishAbtest({
            id: this.abTestDetail.id,
            groupName: this.name,
            abFormList,
            ...(isEnableAttributionWindow() ? {
              metricDisplayMode: validateRes.metricDisplayMode,
            } : {}),
          }).then((res:any) => {
            if (callback) {
              callback(res.data.code===0);
            }
            if (res.data.code!=0) {
              // Message.error('发布失败');
            } else {
              if (validateRes.hasSms) {
                this.$alert(
                  this.$tx('form.edit.err.smsNoEndPage', '“通过短信订阅”不显示结束页。请手动开启短信欢迎流程，系统将自动发放折扣码（请确保短信欢迎流程配置折扣码）'),
                  this.$tx('form.pleaseNote', '请注意'),
                  {
                    confirmButtonText: this.$tx('user.check.confirm', '确认'),
                    showClose: false,
                    callback: () => this.changeDetail()
                  }
                );
              } else {
                Message.success(this.$tx('common.success.publish', '发布成功'));
                this.changeDetail();
              }
            }
          }).catch(() => {
            // Message.error('发布失败');
            if (callback) {
              callback(false);
            }
          })
        } else {
          Message.error(this.$tx('form.notEnoughVariationsInThis', '实验内弹窗不足，请增加实验内弹窗'));
        }
      } else {
        Message.error(this.$tx('form.experimentNameCannotBeEmpty', '实验名称不可为空'));
      }
    } else if (this.customDialogConfig.type === 'cancel') {
      // TODO: 模拟取消成功
      cancelAbtest({
        id: this.abTestDetail.id,
      }).then((res:any) => {
        if (callback) {
          callback(res.data.code===0);
        }
        if (res.data.code!=0) {
          Message.error(this.$tx('form.failedCancel', '取消失败'));
        } else {
          Message.success(this.$tx('form.cancelledSuccessfully', '取消成功'));
          this.jumpToList();
        }
      }).catch((e) => {
        if (e?.handled) {
          return;
        }
        Message.error(this.$tx('form.failedCancel', '取消失败'));
        if (callback) {
          callback(false);
        }
      });
    } else if (this.customDialogConfig.type === 'smartEnd') {
      endSmartABTest({ id: this.abTestDetail.id }).then((res: any) => {
        if (callback) {
          callback(res.data.code === 0);
        }
        if (res.data.code === 0) {
          Message.success(this.$tx('form.smartAb.endOk', '已结束实验，已保留基线'));
          this.changeDetail();
        } else {
          Message.error(toastFailMessage(res.data));
        }
      }).catch(() => {
        if (callback) {
          callback(false);
        }
      });
    } else if (this.customDialogConfig.type === 'smartConfirmSuggest') {
      confirmSmartABTestWin({
        mainFormId: this.abTestDetail.id,
        winFormId: this.customDialogConfig.other,
      }).then((res: any) => {
        if (callback) {
          callback(res.data.code === 0);
        }
        if (res.data.code === 0) {
          Message.success(this.$tx('form.smartAb.confirmOk', '已设为新基线'));
          this.changeDetail();
        } else {
          Message.error(toastFailMessage(res.data));
        }
      }).catch(() => {
        if (callback) {
          callback(false);
        }
      });
    }
  }

  openDataShowVisible() {
    this.changeTableColumnDialogShow = true
  }

  changeMeasure(measures:any) {
    const nextMeasures = normalizeAbtestMeasures(
      measures,
      this.abTestDetail?.metricDisplayMode,
      shouldUseAbtestAttributionMetrics(this.abTestDetail?.metricDisplayMode, isEnableAttributionWindow())
    );
    // TODO: 需后端修改
    companyMeasureSave({
      measureCategory: "FORMABTEST",
      measures: nextMeasures
    }, true).then((res) => {
      // console.log('保存成功');
      this.changeTableColumnDialogShow = false;
      // 重新请求详情
      this.changeDetail();
    })
  }

}
